export const Routes = [
	{
		id: 1,
		identifier: "about",
		title: "about",
		// isDifferentPage: true,
		dropdown: [
			{
				id: 1,
				title: "team",
				identifier: "team",
				isDifferentPage: true,
			},
			{
				id: 2,
				title: "awards",
				identifier: "awards",
				// isDifferentPage: true,
			},
			{
				id: 3,
				title: "infrastructure",
				identifier: "infrastructure",
				// isDifferentPage: true,
			},

		],
	},
	{
		id: 2,
		identifier: "whyjaycee",
		title: "why jaycee",
	},
	{
		id: 3,
		identifier: "clients",
		title: "clients",
		// isDifferentPage: true,
	},
	{
		id: 4,
		identifier: "products",
		title: "products",
		// isDifferentPage:true,
		dropdown: [
			{
				id: 1,
				title: "Diesel Generators",
				identifier: "dieselGenerators",
				isDifferentPage: true,
			},
			// {
			// 	id: 2,
			// 	title: "Portable generators",
			// 	identifier: "portablegenerators",
			// 	// isDifferentPage: true,
			// },
			{
				id: 3,
				title: "Electrical Stamping",
				identifier: "electricalstampings",
				// isDifferentPage: true,
			},
		],
	},
	{
		id: 5,
		identifier: "projects",
		title: "Projects",
		isDifferentPage: true,
	},
	{
		id: 7,
		identifier: "connect",
		title: "Connect",
		isDifferentPage: true,
		dropdown: [
			{
				id: 1,
				title: "locate a dealer",
				identifier: "locateadealer",
				isDifferentPage: true,
			},
		],
	},

]

export default Routes



// WEBPACK FOOTER //
// ./src/components/Routes.js